import { jsonProperty, Serializable } from "ts-serializable";
import { getDescricaoByCodigo } from "../../../enums/Roles";
import Company from "../company/Company";
import Person from "./Person";

class PersonCompany extends Serializable{

    @jsonProperty(String, null)
    id: string | null = null;

    @jsonProperty(Object, null)
    pessoa: Person | null = new Person();

    @jsonProperty(Object, null)
    empresa: Company | null = new Company();

    @jsonProperty([String], null)
    perfis: string[] | null = []

    getRolesDescriptionList = ()=>{
        const rolesDescript: string[] = []
        this.perfis?.forEach(role=>{
            rolesDescript.push(getDescricaoByCodigo(role))
        })

        return rolesDescript
    }
}  



export default PersonCompany;